import * as React from 'react'
import { Button } from 'primereact/button'
import DialogCustom from 'app/shared/components/Dialog'
import { TabMenu } from 'primereact/tabmenu'
import Icon from 'app/shared/components/Icon'
import { PopupComponentProps } from 'app/core/models/component/popupComponent'
import { getAppMode } from 'app/shared/utils/comUtil'

/*======================================================================
 * @ 업무설명 : 약관팝업
 * @ 파 일 명 : src\app\pages\com\agm\COMAGM0101.tsx
 * @ 화면 ID : SC-COM-0002-P
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     김상돈(S24069)   2025.07.10    최초작성
 *======================================================================
 */
export type PdfType = {
    pdfNm: string
    pdfType: string
    pdfUrl: string
}

type PropsPdf = {
    data: PdfType[]
    onAgree: (agree: boolean, targetId?: string) => void
    confirmLabel?: string
    targetId?: string
}

const DialogAgree: React.FC<PopupComponentProps & PropsPdf> = (props) => {
    const iframeRef = React.useRef<HTMLIFrameElement>(null)

    const { data = [], onAgree, confirmLabel, targetId } = props
    const [tabIndex, setTabIndex] = React.useState<number>(0)
    // tab
    const tabItems = props.data?.map((items) => ({
        label: items.pdfNm,
    }))

    const scrollPage = async () => {
        const iframe = iframeRef?.current
        if (data[tabIndex]?.pdfType.toLowerCase() === 'html') {
            const iframeBody = iframe.contentDocument.body

            iframeBody.scrollTo({
                behavior: 'smooth',
                top: iframeBody.scrollTop + iframeBody.clientHeight,
            })
        } else {
            //로컬이면 cors오류

            if (!iframe) {
                return
            }

            const iframeDoc =
                iframe.contentDocument || iframe.contentWindow?.document
            if (!iframeDoc) {
                return
            }

            // viewer 안에도 iframe이 있어서 한 번 더 찾기
            const secondIframe: HTMLIFrameElement =
                iframeDoc.querySelector('body #viewerFrame')

            const secondIframeDoc =
                secondIframe.contentDocument ||
                secondIframe.contentWindow?.document

            // 약관 page 수
            const targetElcnt =
                secondIframeDoc?.getElementsByClassName('page')?.length

            // 약관 page 당 범위
            const visiblePage = Array.from(
                secondIframeDoc?.querySelectorAll('[data-page-number]') || []
            ).find((secondIframeDoc) => {
                const rect = secondIframeDoc.getBoundingClientRect()
                return rect.top < window.innerHeight && rect.bottom > 0
            })

            // 약관 다음 page number
            const pageNum =
                Number(visiblePage.getAttribute('data-page-number')) + 1
            // 스크롤 타겟 위치
            const targetEl = secondIframeDoc?.getElementById('page' + pageNum)

            if (targetEl) {
                targetEl.scrollIntoView({ behavior: 'smooth' })
            } else {
                return
            }
        }
    }

    React.useEffect(() => {
        if (getAppMode() === 'local' || window.location.protocol !== 'https:') {
            return
        }
        const iframe = iframeRef?.current

        if (!iframe) {
            return
        }

        const iframeDoc =
            iframe.contentDocument || iframe.contentWindow?.document
        if (!iframeDoc) {
            return
        }

        if (iframeDoc?.getElementById('page')) {
            const pageItem = iframeDoc?.getElementById('page') as HTMLDivElement

            if (pageItem) {
                pageItem.style.display = 'none'
            }
        }
    }, [iframeRef.current])

    React.useEffect(() => {
        if (props.visible) setTabIndex(0)
    }, [props.visible])

    const baseUrl =
        getAppMode() === 'local'
            ? 'http://mbrdev.ibk.co.kr/'
            : window.location.origin

    return (
        <DialogCustom
            visible={props.visible}
            closeFocus={props.closeFocus ?? ''}
            header="약관상세"
            className="dialog-full dialog-agree-view"
            onClose={() => {
                onAgree(false, targetId)
            }}
            footer={
                <Button
                    label={!confirmLabel ? '동의하기' : confirmLabel}
                    className="button-basic-primary -lg width-full"
                    onClick={() => {
                        if (
                            tabItems.length > 1 &&
                            tabItems.length !== tabIndex + 1
                        ) {
                            setTabIndex((prev) => prev + 1)
                        } else {
                            onAgree(true, targetId)
                        }
                    }}
                />
            }
        >
            <div className="tabs-wrap">
                <TabMenu
                    className={`tabs-line ${
                        tabItems.length > 1 ? '-reel' : ''
                    }`.trim()}
                    activeIndex={tabIndex}
                    model={tabItems}
                    onTabChange={(e) => setTabIndex(e.index)}
                />
            </div>

            <iframe
                key={data[tabIndex]?.pdfNm}
                ref={iframeRef}
                src={
                    data[tabIndex]?.pdfType.toLowerCase() === 'html'
                        ? data[tabIndex]?.pdfUrl
                        : baseUrl +
                          '/uib/pdf/ezpdf/unidocswv/ezpdf1/viewer.jsp?path=' +
                          encodeURIComponent(data[tabIndex]?.pdfUrl)
                }
            />

            <div
                className={`fraction${props.data?.length < 2 ? ' -hide' : ''}`}
            >
                <em>{tabIndex + 1}</em>/<span>{props.data?.length}</span>
            </div>

            <Button
                className="btn-bottom-go"
                onClick={() => {
                    scrollPage()
                }}
            >
                <Icon name="arrow-bottom" text="page 한 칸 이동" />
            </Button>
        </DialogCustom>
    )
}

export default DialogAgree
export const COMAGM0101 = DialogAgree
